import { SEARCH_KEYS } from '../../constants/query-params/search';

export const searchStateToGqlSorting = (search: SearchState, GQLSortingMap: { [key: string]: string }) => {
    const selectedSortingOptionId = search[SEARCH_KEYS.SORTING];

    if (selectedSortingOptionId && GQLSortingMap[selectedSortingOptionId]) {
        return `order_by: ${GQLSortingMap[selectedSortingOptionId]}`;
    }

    return '';
};
